<template>
  <InputGroup class="w-fit!">
    <IconButton
      v-if="showImport"
      v-tooltip.top="importTooltip ? importTooltip : 'Import ' + label"
      icon="file-import"
      outlined
      :small
      :disabled="importDisabled"
      @click="emit('import')"
    >
    </IconButton>
    <IconButton
      v-if="showCreate"
      v-tooltip.top="createTooltip ? createTooltip : 'Create ' + label"
      icon="wrench"
      outlined
      :small
      :disabled="createDisabled"
      @click="emit('create')"
    ></IconButton>
    <IconButton
      v-if="showAdd"
      v-tooltip.top="addTooltip ? addTooltip : 'Add ' + label"
      icon="plus"
      outlined
      :small
      :disabled="addDisabled"
      @click="emit('add')"
    >
    </IconButton>
    <IconButton
      v-if="showArchive"
      v-tooltip.top="archiveTooltip ? archiveTooltip : 'Archive ' + label"
      icon="inbox"
      outlined
      :small
      :disabled="archiveDisabled"
      @click="emit('archive')"
    >
    </IconButton>
    <IconButton
      v-if="showSave"
      v-tooltip.top="saveTooltip ? saveTooltip : 'Save ' + label"
      icon="save"
      outlined
      :small
      :disabled="deleteDisabled"
      @click="emit('delete')"
    >
    </IconButton>
    <IconButton
      v-if="showDelete"
      v-tooltip.top="deleteTooltip ? deleteTooltip : 'Delete ' + label"
      icon="trash"
      outlined
      :small
      :disabled="deleteDisabled"
      @click="emit('delete')"
    >
    </IconButton>
    <IconButton
      v-if="showUnlock"
      v-tooltip.top="unlockTooltip ? deleteTooltip : 'Unlock ' + label"
      icon="lock-open"
      outlined
      :small
      :disabled="unlockDisabled"
      @click="emit('unlock')"
    >
    </IconButton>
  </InputGroup>
</template>

<script setup lang="ts">
interface Props {
  label: string;
  small?: boolean;
  showImport?: boolean;
  showCreate?: boolean;
  showAdd?: boolean;
  showArchive?: boolean;
  showSave?: boolean;
  showDelete?: boolean;
  showUnlock?: boolean;
  importDisabled?: boolean;
  createDisabled?: boolean;
  addDisabled?: boolean;
  archiveDisabled?: boolean;
  saveDisabled?: boolean;
  deleteDisabled?: boolean;
  unlockDisabled?: boolean;
  importTooltip?: string;
  createTooltip?: string;
  addTooltip?: string;
  archiveTooltip?: string;
  saveTooltip?: string;
  deleteTooltip?: string;
  unlockTooltip?: string;
}
const props = withDefaults(defineProps<Props>(), {
  small: false,
  showImport: false,
  showCreate: false,
  showAdd: false,
  showArchive: false,
  showSave: false,
  showDelete: false,
  showUnlock: false,
  importDisabled: false,
  createDisabled: false,
  addDisabled: false,
  archiveDisabled: false,
  saveDisabled: false,
  deleteDisabled: false,
  unlockDisabled: false,
});

const emit = defineEmits<{
  import: [];
  create: [];
  add: [];
  archive: [];
  save: [];
  delete: [];
  unlock: [];
}>();
</script>
